import {
  EDIT_COLLECTION_SUCCEEDED,
  GET_COLLECTION_SUCCEEDED,
  ATTACH_PRODUCT_TO_COLLECTION_SUCCEEDED,
  GET_COLLECTION_REQUESTED,
  RESPOND_COLLECTION_SUCCEEDED,
  SEND_COLLECTION_PICKUP_CONFIRMATION_SUCCEEDED,
  SEND_COLLECTION_TO_SHOOT_SUCCEEDED,
  SEND_COLLECTION_CONSIGNMENT_AGREEMENT_SUCCEEDED,
  IMPORT_PRODUCT_FROM_FILE_REQUESTED,
  IMPORT_PRODUCT_FROM_FILE_SUCCEEDED,
  ATTACH_PRODUCT_TO_COLLECTION_FAILED,
  IMPORT_PRODUCT_FROM_FILE_FAILED,
  IMPORT_PRODUCT_FROM_FILE_COMPLETED,
  GET_IMPORT_HISTORIES_REQUESTED,
  GET_IMPORT_HISTORIES_SUCCEEDED,
  SEND_COLLECTION_TO_WAREHOUSE_SUCCEEDED
} from './edit.actions';
import * as _ from 'lodash';

export const edit = (state = { updated: false, fetched: false, item: {}, uploadReceipt: null, importHistories: [] }, action) => {
  switch (action.type) {
    case GET_COLLECTION_SUCCEEDED:
      return _.assign({}, state, { updated: false, fetched: true, item: action.data });

    case GET_COLLECTION_REQUESTED:
      return _.assign({}, state, { updated: false, fetched: false, item: {} });

    case EDIT_COLLECTION_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true });

    case IMPORT_PRODUCT_FROM_FILE_REQUESTED:
      return _.assign({}, state, { updated: false, fetched: false, item: state.item });

    case IMPORT_PRODUCT_FROM_FILE_COMPLETED:
      return _.assign({}, state, { updated: false, fetched: false, item: state.item, uploadReceipt: action.data });
    case IMPORT_PRODUCT_FROM_FILE_FAILED:
      return _.assign({}, state, { updated: true, fetched: true, item: state.item, uploadReceipt: ''  });
    case IMPORT_PRODUCT_FROM_FILE_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true, item: state.item, uploadReceipt: ''  });

    case ATTACH_PRODUCT_TO_COLLECTION_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true, item: action.data });

    case RESPOND_COLLECTION_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true, item: action.data  });

    case SEND_COLLECTION_PICKUP_CONFIRMATION_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true, item: action.data  });

    case SEND_COLLECTION_TO_SHOOT_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true, item: action.data  });

    case SEND_COLLECTION_TO_WAREHOUSE_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true, item: action.data  });

    case SEND_COLLECTION_CONSIGNMENT_AGREEMENT_SUCCEEDED:
      return _.assign({}, state, { updated: true, fetched: true, item: action.data  });

    case GET_IMPORT_HISTORIES_REQUESTED:
      return _.assign({}, state, { importHistories: []  });

    case GET_IMPORT_HISTORIES_SUCCEEDED:
      return _.assign({}, state, { importHistories: action.data  });
    default:
      return state;
  }
}
